import * as ambassadorWixEcomOrdersV1Invoice from './ecom-orders-v1-invoice-order-invoices.http.js';
import * as ambassadorWixEcomOrdersV1InvoiceTypes from './ecom-orders-v1-invoice-order-invoices.types.js';
import * as ambassadorWixEcomOrdersV1InvoiceUniversalTypes from './ecom-orders-v1-invoice-order-invoices.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listInvoicesForMultipleOrders(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomOrdersV1InvoiceUniversalTypes.ListInvoicesForMultipleOrdersRequest,
  ambassadorWixEcomOrdersV1InvoiceTypes.ListInvoicesForMultipleOrdersRequest,
  ambassadorWixEcomOrdersV1InvoiceUniversalTypes.ListInvoicesForMultipleOrdersResponse &
    ambassadorWixEcomOrdersV1InvoiceUniversalTypes.ListInvoicesForMultipleOrdersResponseNonNullableFields,
  ambassadorWixEcomOrdersV1InvoiceTypes.ListInvoicesForMultipleOrdersResponse &
    ambassadorWixEcomOrdersV1InvoiceTypes.ListInvoicesForMultipleOrdersResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomOrdersV1Invoice.listInvoicesForMultipleOrders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/invoices/list-by-ids',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function generateInvoice(): __PublicMethodMetaInfo<
  'POST',
  { orderId: string },
  ambassadorWixEcomOrdersV1InvoiceUniversalTypes.GenerateInvoiceRequest,
  ambassadorWixEcomOrdersV1InvoiceTypes.GenerateInvoiceRequest,
  ambassadorWixEcomOrdersV1InvoiceUniversalTypes.GenerateInvoiceResponse &
    ambassadorWixEcomOrdersV1InvoiceUniversalTypes.GenerateInvoiceResponseNonNullableFields,
  ambassadorWixEcomOrdersV1InvoiceTypes.GenerateInvoiceResponse &
    ambassadorWixEcomOrdersV1InvoiceTypes.GenerateInvoiceResponseNonNullableFields
> {
  const payload = { orderId: ':orderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomOrdersV1Invoice.generateInvoice(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/invoices/orders/{orderId}',
    pathParams: { orderId: 'orderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkGenerateInvoices(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomOrdersV1InvoiceUniversalTypes.BulkGenerateInvoicesRequest,
  ambassadorWixEcomOrdersV1InvoiceTypes.BulkGenerateInvoicesRequest,
  ambassadorWixEcomOrdersV1InvoiceUniversalTypes.BulkGenerateInvoicesResponse &
    ambassadorWixEcomOrdersV1InvoiceUniversalTypes.BulkGenerateInvoicesResponseNonNullableFields,
  ambassadorWixEcomOrdersV1InvoiceTypes.BulkGenerateInvoicesResponse &
    ambassadorWixEcomOrdersV1InvoiceTypes.BulkGenerateInvoicesResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomOrdersV1Invoice.bulkGenerateInvoices(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/invoices/generate',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addInvoiceToOrder(): __PublicMethodMetaInfo<
  'POST',
  { orderId: string },
  ambassadorWixEcomOrdersV1InvoiceUniversalTypes.AddInvoiceToOrderRequest,
  ambassadorWixEcomOrdersV1InvoiceTypes.AddInvoiceToOrderRequest,
  ambassadorWixEcomOrdersV1InvoiceUniversalTypes.AddInvoiceToOrderResponse &
    ambassadorWixEcomOrdersV1InvoiceUniversalTypes.AddInvoiceToOrderResponseNonNullableFields,
  ambassadorWixEcomOrdersV1InvoiceTypes.AddInvoiceToOrderResponse &
    ambassadorWixEcomOrdersV1InvoiceTypes.AddInvoiceToOrderResponseNonNullableFields
> {
  const payload = { orderId: ':orderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomOrdersV1Invoice.addInvoiceToOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/invoices/orders/{orderId}/add-invoice',
    pathParams: { orderId: 'orderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
